"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polygonDefaultOptions = exports.googleMapDefaultOptions = void 0;

var _colors = _interopRequireDefault(require("../../../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var googleMapDefaultOptions = {
  mapTypeControl: false
};
exports.googleMapDefaultOptions = googleMapDefaultOptions;

var polygonDefaultOptions = function polygonDefaultOptions(colorPolygon, colorBorderPolygon) {
  return {
    strokeWeight: 2,
    strokeOpacity: 0.8,
    strokeColor: colorBorderPolygon || _colors["default"].map,
    fillColor: colorPolygon || _colors["default"].map,
    fillOpacity: 0.35
  };
};

exports.polygonDefaultOptions = polygonDefaultOptions;